import { endpoints } from './config';

export const displayData = async ({ filter = 'daily', param = '', start_date = '', end_date = ''}) => {
  const url = start_date && end_date
    ? `${endpoints.displayData}?filter=custom&param=${param}&start_date=${start_date}&end_date=${end_date}`
    : `${endpoints.displayData}?filter=${filter}&param=${param}`;

  console.log(url);

  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();

    if (data.status === 'error') {
      throw new Error(data.data);
    }

    return { status: 'success', data: data.data };
  } catch (error) {
    return { status: 'error', message: error.message || 'There is no data available for the selected filters.' };
  }
};

export const recentData = async () => {
  const url = `${endpoints.recentData}`;  

  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();

    if (data.status === 'error') {
      throw new Error(data.message);
    }

    return { status: 'success', data: data.data };
  } catch (error) {
    return { status: 'error', message: error.message || 'Unable to fetch recent data.' };
  }
};

export const fetchHistory = async (page = 1, recordsPerPage = 10) => {
  try {
    // Construct the URL with query parameters
    const url = `${endpoints.getHistory}?page=${page}&records_per_page=${recordsPerPage}`;
    
    // Fetch data from the API
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error displaying history data' };
      }

      // Return the success response including the data and pagination details
      return {
        status: 'success',
        data: data.data,
        pagination: data.pagination,
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during fetching history data:', error);
    return { status: 'error', message: 'An error occurred while fetching history data. Please try again.' };
  }
};

export const fetchCHHistory = async (page = 1, recordsPerPage = 10) => {
  try {
    // Construct the URL with query parameters
    const url = `${endpoints.getCHHistory}?page=${page}&records_per_page=${recordsPerPage}`;
    
    // Fetch data from the API
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error displaying history data' };
      }

      // Return the success response including the data and pagination details
      return {
        status: 'success',
        data: data.data,
        pagination: data.pagination,
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during fetching history data:', error);
    return { status: 'error', message: 'An error occurred while fetching history data. Please try again.' };
  }
};

export const deleteHistory = async (history_id) => {
  try {
    const url = `${endpoints.deleteHistory}?history_id=${history_id}`;
    
    // Fetch the delete request from the API
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error deleting history data' };
      }

      // Return the success response indicating successful deletion
      return {
        status: 'success',
        message: data.message || 'History record deleted successfully',
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during deleting history data:', error);
    return { status: 'error', message: 'An error occurred while deleting history data. Please try again.' };
  }
};

export const login = async (userData) => {
  const url = `${endpoints.login}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData), 
    });

    const data = await response.json();

    if (data.status === 'success') {
      return { status: 'success', message: data.message, user: data.user };
    } else {
      return { status: 'error', message: data.message };
    }
  } catch (error) {
    console.error('Error during logging in:', error);
    return { status: 'error', message: 'An error occurred during loggin in. Please try again.' };
  }
};

export const userInsert = async (username, api_key, userData) => {
  const url = `${endpoints.userInsert}?username=${username}&api_key=${api_key}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData), 
    });

    const data = await response.json();

    if (data.status === 'success') {
      return { status: 'success', message: data.message };
    } else {
      return { status: 'error', message: data.message };
    }
  } catch (error) {
    console.error('Error during inserting data:', error);
    return { status: 'error', message: 'An error occurred during inserting data. Please try again.' };
  }
};

export const allData = async (filter = 'daily', start_date = '', end_date = '', page = 1, limit = 10) => {
  try {
    // Construct the URL with query parameters
    const url = start_date && end_date
    ? `${endpoints.allData}?filter=custom&start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${limit}`
    : `${endpoints.allData}?filter=${filter}&page=${page}&limit=${limit}`;
    
    // Fetch data from the API
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error displaying history data' };
      }

      // Return the success response including the data and pagination details
      return {
        status: 'success',
        data: data.data,
        pagination: data.pagination,
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during fetching bfar data:', error);
    return { status: 'error', message: 'An error occurred while fetching bfar data. Please try again.' };
  }
};

export const managedData = async (filter = 'daily', start_date = '', end_date = '', page = 1, limit = 10, api_key = '') => {
  try {
    // Construct the URL with query parameters
    const url = start_date && end_date
    ? `${endpoints.managedData}?filter=custom&start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${limit}&api_key=${api_key}`
    : `${endpoints.managedData}?filter=${filter}&page=${page}&limit=${limit}&api_key=${api_key}`;
    
    // Fetch data from the API
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error displaying history data' };
      }

      // Return the success response including the data and pagination details
      return {
        status: 'success',
        data: data.data,
        pagination: data.pagination,
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during fetching bfar data:', error);
    return { status: 'error', message: 'An error occurred while fetching bfar data. Please try again.' };
  }
};

export const deleteData = async (id) => {
  try {
    const url = `${endpoints.deleteData}?id=${id}`;
    
    // Fetch the delete request from the API
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error deleting bfar data' };
      }

      // Return the success response indicating successful deletion
      return {
        status: 'success',
        message: data.message || 'BFAR record deleted successfully',
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during deleting bfar data:', error);
    return { status: 'error', message: 'An error occurred while deleting bfar data. Please try again.' };
  }
};

export const deleteCHData = async (id) => {
  try {
    const url = `${endpoints.deleteCHHistory}?id=${id}`;
    
    // Fetch the delete request from the API
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Parse the response text
    const textResponse = await response.text();

    try {
      // Attempt to parse the JSON response
      const data = JSON.parse(textResponse);

      // Handle the response status
      if (data.status === 'error') {
        return { status: 'error', message: data.message || 'Error deleting bfar data' };
      }

      // Return the success response indicating successful deletion
      return {
        status: 'success',
        message: data.message || 'BFAR record deleted successfully',
      };
    } catch (jsonError) {
      // Handle invalid JSON
      console.error('Invalid JSON response:', textResponse);
      return { status: 'error', message: 'Invalid response from the server' };
    }
  } catch (error) {
    // Handle fetch errors
    console.error('Error during deleting bfar data:', error);
    return { status: 'error', message: 'An error occurred while deleting bfar data. Please try again.' };
  }
};